var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.vueAppClasses,style:(_vm.customStyle),attrs:{"id":"app","id":_vm.customIds}},[_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}}),_c('hover-call-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }